import React from 'react';
import * as styles from './ReservedContentPopUp.module.scss';
import { useTranslation } from 'react-i18next';

interface PopUpProps {
  onButtonClick: () => void;
}

const ReservedContentPopUp = ({ onButtonClick }: PopUpProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <div className={styles.popUpContainer}>
      <h3 className={styles.popUpTitle}>{t('reserved_content_pop_up.title', 'Attention')}</h3>
      <span className={styles.popUpDescription}>
        {t(
          'reserved_content_pop_up.description',
          'The content of this website is for farmers and professionals in the agricultural sector.',
        )}
      </span>
      <button onClick={onButtonClick} className={styles.popUpButton}>
        {t('reserved_content_pop_up.button', 'Confirm')}
      </button>
    </div>
  );
};

export default ReservedContentPopUp;
